import Wrap, { Backdrop, StyledButton } from './styles';

import { phoneNumber } from 'services/utils/inputMasks';
import message from 'services/utils/messages';

import validationSchema from './validationSchema';

import { publicNetwork } from '@adm/services/networkRequest';
import FormikMaskedTextInput from '@map/components/Formik/components/MaskedTextInput';
import FormikTextInput from '@map/components/Formik/components/TextInput';
import SimpleModal from '@map/components/SimpleModal';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * Componente Contato
 * É atraves dele que é possivel entrar em contato para duvidas melhorias
 * ou suporte, la também é possivel achar o numero para denuncias, ouvidoria
 * do inema, ouvidoria geral do estado e o email de contato do geobahia/inema.
 * 
 * @returns Um formulario.
 */
const Contact = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permitted, setPermitted] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const reCaptchaClientKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const onReCaptchaChange = (value) => {
    if (value) {
      setPermitted(true);
    } else {
      setPermitted(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      subject: '',
      name: '',
      email: '',
      phone: '',
      message: '',
    },
    validationSchema,
    validateOnChange: true,
    onSubmit: ({
      name: nome,
      email,
      subject: assunto,
      phone: telefone,
      message: mensagem,
    }) => {
      if (permitted) {
        setLoading(true);
        publicNetwork
          .post('/contato', {
            nome,
            email,
            telefone,
            assunto,
            mensagem,
          })
          .then(({ data }) => {
            if (data.mensagem) {
              enqueueSnackbar({
                message: message[data.mensagem],
                variant: 'success',
              });
              formik.resetForm();
              setOpen(false);
            }
          })
          .catch((error) => {
            if (error.response.data?.detail?.mensagem) {
              enqueueSnackbar({
                message: message[error.response.data.detail.mensagem],
                variant: 'error',
              });
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        enqueueSnackbar({
          message: 'É necessário validar o reCAPTCHA',
          variant: 'warning',
        });
      }
    },
  });

  const onClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  /**
   * @returns O Formulario para preenchimento pelo usuario para 
   * entrar em contato com o geobahia/inema.
   */
  return (
    <>
      <Backdrop open={open} onClick={onClose} />
      <SimpleModal
        title="Contatos"
        draggable={false}
        open={open}
        onClose={onClose}
      >
        <Wrap>
          <div>
            <form onSubmit={formik.handleSubmit}>
              <FormikTextInput
                formik={formik}
                type="text"
                placeholder="Assunto"
                name="subject"
                maxLength="60"
                width="304"
              />
              <FormikTextInput
                formik={formik}
                type="text"
                placeholder="Nome"
                name="name"
                maxLength="50"
                width="268"
              />
              <FormikTextInput
                formik={formik}
                type="text"
                placeholder="E-mail"
                name="email"
                minLength="3"
                maxLength="50"
                width="304"
              />
              <FormikMaskedTextInput
                formik={formik}
                type="text"
                placeholder="Telefone"
                name="phone"
                minLength="3"
                maxLength="50"
                width="169"
                guide={false}
                mask={phoneNumber()}
              />
              <FormikTextInput
                formik={formik}
                type="multiline"
                placeholder="Digite sua mensagem aqui"
                name="message"
                width="304"
                height="165"
              />
              <ReCAPTCHA
                id="recaptcha"
                sitekey={reCaptchaClientKey}
                onChange={onReCaptchaChange}
              />
              <StyledButton
                variant="contained"
                color={loading || !permitted ? 'loading' : 'primary'}
                type="submit"
              >
                {loading ? 'Enviando...' : 'Enviar'}
              </StyledButton>
            </form>
          </div>
          <div>
            <h3>Telefones</h3>
            <section>
              <span className="phone">08000 71 1400</span>
              <span className="description">Disque denúncia</span>
            </section>
            <section>
              <span className="phone">0800 284 1400</span>
              <span className="phone">3118-4553 | 3118-4554</span>
              <span className="description">Ouvidoria INEMA</span>
            </section>
            <section>
              <span className="phone">0800 284 0011</span>
              <span className="description">Ouvidoria Geral do Estado</span>
            </section>
            <div className="space"></div>
            <h3>E-mail</h3>
            <a href="mailto:contatogeobahia@inema.ba.gov.br">
              contatogeobahia@inema.ba.gov.br
            </a>
          </div>
        </Wrap>
      </SimpleModal>
      <button onClick={() => setOpen(true)}>Contato</button>
    </>
  );
};

Contact.properties = {
  id: 'CPN-HB-CONTACT',
  alias: 'Módulo de Contato',
  description:
    'Botão de acesso ao modal de contato para comunicação com equipe de suporte do GEOBAHIA',
};

export default Contact;
